import React, { createContext, useState, useContext, useMemo } from 'react';
import en from './locales/en.json';
import zh from './locales/zh.json';

const translations = { en, zh };

const I18nContext = createContext();

export const I18nProvider = ({ children }) => {
    const [language, setLanguage] = useState('en');

    const t = useMemo(() => (key, params = {}) => {
        let translation = translations[language][key] || key;
        Object.keys(params).forEach(paramKey => {
            translation = translation.replace(`\${${paramKey}}`, params[paramKey]);
        });
        return translation;
    }, [language]);

    return (
        <I18nContext.Provider value={{ language, setLanguage, t }}>
            {children}
        </I18nContext.Provider>
    );
};

export const useTranslation = () => {
    const context = useContext(I18nContext);
    if (!context) {
        throw new Error('useTranslation must be used within an I18nProvider');
    }
    return context;
};